var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0792 4.93596C14.1792 7.13596 12.3792 9.43598 10.6792 11.736C9.87922 10.336 9.07922 8.83599 8.37922 7.33599C6.67922 4.03599 1.57922 6.93597 3.37922 10.336C4.77922 13.136 6.37922 15.936 7.97922 18.636C9.17922 20.636 11.7792 20.436 12.9792 18.636C15.2792 15.336 17.6792 12.236 20.2792 9.13598C22.5792 6.23598 18.4792 2.13596 16.0792 4.93596Z",
    fill: "#32B2A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8792 20.336C10.6792 20.336 10.5792 20.236 10.4792 20.136C8.07919 17.236 5.87918 14.136 3.77918 10.936C3.57918 10.736 3.67918 10.436 3.87918 10.236C4.07918 10.036 4.37919 10.136 4.57919 10.336C6.47919 13.336 8.57918 16.136 10.7792 18.936C13.8792 15.036 16.3792 11.336 19.3792 6.53597C19.4792 6.33597 19.8792 6.23599 20.0792 6.33599C20.2792 6.43599 20.3792 6.83597 20.2792 7.03597C17.0792 12.036 14.4792 15.836 11.1792 20.036C11.1792 20.236 10.9792 20.336 10.8792 20.336Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYes);
export default __webpack_public_path__ + "static/media/yes.a54a6d06e1bd3696a85452215970e887.svg";
export { ForwardRef as ReactComponent };